import { render, staticRenderFns } from "./HeaderNavigationCategory.vue?vue&type=template&id=74912827&scoped=true&"
import script from "./HeaderNavigationCategory.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavigationCategory.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNavigationCategory.vue?vue&type=style&index=0&id=74912827&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74912827",
  null
  
)

export default component.exports